import { render, staticRenderFns } from "./CheckAllRecieversPackage.vue?vue&type=template&id=c6b55266&scoped=true"
import script from "./CheckAllRecieversPackage.vue?vue&type=script&lang=js"
export * from "./CheckAllRecieversPackage.vue?vue&type=script&lang=js"
import style0 from "./CheckAllRecieversPackage.vue?vue&type=style&index=0&id=c6b55266&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6b55266",
  null
  
)

export default component.exports